import React from 'react';
import styled from "styled-components";


const OptionName = styled.p`
    font-size: var(--font-XS);
    margin: 0;
    padding-top:0.20rem;
    padding-left: 0.5rem;
    font-weight: ${({ $emphasized }) => $emphasized ? 'bold' : 'normal'};

    @media (max-width: 578px) {
        font-size: var(--font-M);
    }

`
// A second, quieter line under the option's name — the official wording of a
// VAT code under its short name, for one.
const OptionSubtitle = styled.p`
    font-size: var(--font-XXS);
    margin: 0;
    padding-left: 0.5rem;
    padding-bottom: 0.15rem;
    opacity: 0.7;
`
// The letter that picks this option from the keyboard (SelectControl), shown
// as a key cap so it is learnt by looking at the list.
const OptionRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-right: 0.5rem;
`
const ShortcutKey = styled.kbd`
    font-family: inherit;
    font-size: var(--font-XXS);
    min-width: 1.4rem;
    text-align: center;
    padding: 0 0.3rem;
    border: 1px solid ${({ theme }) => theme.form.border};
    border-radius: 0.25rem;
    color: ${({ theme }) => theme.font.label};
    background: transparent;
`
const HeaderItem = styled.li`
    pointer-events: none;
    color: ${ ({theme}) => theme.font.highlight };
    padding-left: 0.5rem;

`

// Bold alone barely registers for light text on a dark background, so in dark
// mode an emphasised row also takes the accent text colour. `.emphasized` is
// declared before the hover/active rule so the selected colours still win.
const ListItem = styled.li`
    cursor: pointer;

    &.emphasized {
        color: ${({ theme }) => theme.mode === 'dark' ? theme.font.active : 'inherit'};
    }

    &.active, &:hover {
    background-color: ${({ theme }) => theme.dropdown.selectedBackground};
    border-color: #d3d5d7;
    color: ${({ theme }) => theme.dropdown.selectedFont};
    }

    /* Not pickable under the picker's 'selectable' rule. Keeps its own colour
       so a bold header/sum account still reads as one; it just ignores the mouse. */
    &.disabled {
        pointer-events: none;
    }

    &.unselectable {
        pointer-events: none;
        color: ${({ theme }) => theme.font.highlight};
    }

    @media (max-width: 578px) {
    }
`

const SelectMenuItem = ({
    name,
    id,
    idx,
    header,
    onSelectItem,
    isHighlighted,
    displayId = false,
    testId,
    unselectable = false,
    emphasized = false,
    disabled = false,
    subtitle,
    shortcut
}) => {

    //If the name is undefined, we set it to the id
    if (name === undefined || name === null) {
        name = id;
    }
   
    return (
        <React.Fragment>
            {header ? <HeaderItem id={id} role="presentation">{name}</HeaderItem> :
                <ListItem
                    role="option"
                    aria-selected={isHighlighted}
                    aria-disabled={disabled || undefined}
                    className={`list-group-item ${isHighlighted ? "active highlighted" : ""
                        } ${unselectable ? "unselectable" : ""} ${emphasized ? "emphasized" : ""} ${disabled ? "disabled" : ""}`}
                    onMouseDown={(e) => e.preventDefault()}
                    onClick={onSelectItem}
                    data-testid={`${testId}.${idx+1}`}
                >
                    <OptionRow>
                        {displayId && <OptionName $emphasized={emphasized}>{`${id} - ${name}`}</OptionName>}
                        {!displayId && <OptionName $emphasized={emphasized}>{`${name}`}</OptionName>}
                        {shortcut && <ShortcutKey>{shortcut}</ShortcutKey>}
                    </OptionRow>
                    {subtitle && subtitle !== name && <OptionSubtitle>{subtitle}</OptionSubtitle>}
                </ListItem>
            }
        </React.Fragment>

    );
};

export default SelectMenuItem;